"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

require("../css/sidemenu.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SideMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SideMenu, _React$Component);

  function SideMenu(props) {
    var _this;

    _classCallCheck(this, SideMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideMenu).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleVisibility", function (event) {
      event.preventDefault();

      _this.setState(function (state) {
        return {
          isExpanded: !state.isExpanded
        };
      });
    });

    _this.state = {
      isExpanded: props.expanded
    };
    return _this;
  }

  _createClass(SideMenu, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var isExpanded = this.state.isExpanded;

      if (isExpanded !== nextProps.expanded) {
        this.setState({
          isExpanded: nextProps.expanded
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          children = _this$props.children,
          logoImagePath = _this$props.logoImagePath,
          logoTitle = _this$props.logoTitle,
          logoUrl = _this$props.logoUrl,
          theme = _this$props.theme,
          other = _objectWithoutProperties(_this$props, ["children", "logoImagePath", "logoTitle", "logoUrl", "theme"]);

      var expanded = other.expanded,
          rootProps = _objectWithoutProperties(other, ["expanded"]);

      var isExpanded = this.state.isExpanded;
      var classes = (0, _classnames2.default)((_classnames = {
        'vn-side-menu': true
      }, _defineProperty(_classnames, "vn-side-menu--".concat(theme, "-theme"), true), _defineProperty(_classnames, 'vn-side-menu--expanded', isExpanded), _classnames));
      return _react.default.createElement("nav", _extends({}, rootProps, {
        className: classes
      }), _react.default.createElement("div", {
        className: "vn-side-menu__overlay",
        onClick: this.handleVisibility
      }), _react.default.createElement("a", {
        className: "vn-side-menu__logo",
        href: logoUrl,
        title: logoTitle
      }, _react.default.createElement("img", {
        alt: logoTitle,
        className: "vn-side-menu__logo-image",
        src: logoImagePath
      })), _react.default.createElement("div", {
        className: "vn-side-menu__menu"
      }, _react.default.createElement("ul", null, children)), _react.default.createElement("a", {
        className: "vn-side-menu__toggle",
        onClick: this.handleVisibility,
        "aria-controls": "menu",
        "aria-label": "Navigation",
        role: "button",
        tabIndex: 0
      }, _react.default.createElement(_icon.default, {
        className: "vn-side-menu__toggle-icon",
        name: "menu",
        display: isExpanded ? 'none' : 'block'
      }), _react.default.createElement(_icon.default, {
        className: "vn-side-menu__toggle-icon-rotate",
        name: "chevron",
        display: isExpanded ? 'block' : 'none'
      })));
    }
  }]);

  return SideMenu;
}(_react.default.Component);

SideMenu.propTypes = {
  children: _propTypes.default.node.isRequired,
  expanded: _propTypes.default.bool,
  logoImagePath: _propTypes.default.string,
  logoUrl: _propTypes.default.string,
  logoTitle: _propTypes.default.string,
  theme: _propTypes.default.oneOf(['hp', 'veneer'])
};
SideMenu.defaultProps = {
  expanded: false,
  logoImagePath: null,
  logoUrl: null,
  logoTitle: null,
  theme: 'hp'
};
SideMenu.displayName = 'SideMenu';
var _default = SideMenu;
exports.default = _default;